import React, { useEffect, useState } from "react";
import {
  getWrapupCodes,
  putWrapupcode,
  searchWrapupCodes,
  postWrapupCodesInQueues,
  getQueue,
} from "../utilities/genesysCloudUtils";
import "../App.css";
import {
  AlertBlock,
  DxButton,
  DxCheckbox,
  DxItemGroup,
  DxTextbox,
} from "genesys-react-components";
import { GenesysDevIcon, GenesysDevIcons } from "genesys-dev-icons";
import { Loading } from "./Loading";

export function WrapupCodes({
  divisionsItemGroup,
  setPageCount,
  pageNumber,
  setPageNumber,
  searchWrapupCodesValue,
}) {
  const [wrapupCodes, setWrapupCodes] = useState([]);
  const [editingCodeId, setEditingCodeId] = useState(null);
  const [editingName, setEditingName] = useState("");
  const [editingDescription, setEditingDescription] = useState("");
  const [editingDivision, setEditingDivision] = useState("");
  const [filteredWrapupCodes, setFilteredWrapupCodes] = useState([]);
  const [selectedWrapupCodes, setSelectedWrapupCodes] = useState([]);
  const [queueResults, setQueueResults] = useState([]);
  const [selectedQueues, setSelectedQueues] = useState([]);
  const [confirmation, setConfirmation] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setPageNumber(1);
  }, []);

  useEffect(() => {
    generateWrapupCodes();
  }, [pageNumber]);

  useEffect(() => {
    if (searchWrapupCodesValue) {
      searchWrapupCodes(searchWrapupCodesValue).then((data) => {
        setFilteredWrapupCodes(data.entities);
        setPageCount(data.pageCount);
      });
    } else {
      generateWrapupCodes();
    }
  }, [searchWrapupCodesValue]);

  const generateWrapupCodes = () => {
    let opts = {
      pageSize: 500, // Number | Page size
      pageNumber: pageNumber,
      sortBy: "name", // String | Sort by
      sortOrder: "ascending", // String | Sort order
      name: `*${searchWrapupCodesValue}*`, // String | Name
    };
    setIsLoading(true);
    getWrapupCodes(opts).then((data) => {
      setWrapupCodes(data.entities);
      setPageCount(data.pageCount);
      setIsLoading(false);
    });
  };

  const unselectedDivisions = () => {
    let unselectedDivisions = divisionsItemGroup.filter(
      (item) => item.isSelected
    );
    unselectedDivisions.map((item) => {
      item.isSelected = false;
      return item;
    });
    return unselectedDivisions;
  };

  const handleEditClick = (wrapupCode) => {
    setEditingCodeId(wrapupCode.id);
    setEditingName(wrapupCode.name);
    setEditingDescription(wrapupCode.description);
    setEditingDivision(wrapupCode.division.id);
    unselectedDivisions();
    let selectedDivision = divisionsItemGroup.find(
      (item) => item.value === wrapupCode.division.id
    );
    selectedDivision.isSelected = true;
  };

  const handleNameChange = (value) => {
    setEditingName(value);
  };

  const handleDescriptionChange = (value) => {
    setEditingDescription(value);
  };

  const handleDivisionChange = (value) => {
    setEditingDivision(value);
  };

  const handleSave = (wrapupCode) => {
    const updatedWrapupCode = {
      ...wrapupCode,
      name: editingName,
      description: editingDescription,
      division: { id: editingDivision },
    };
    putWrapupcode(wrapupCode.id, updatedWrapupCode)
      .then((response) => {
        setEditingCodeId(null);
        if (searchWrapupCodesValue) {
          searchWrapupCodes(searchWrapupCodesValue).then((data) => {
            setFilteredWrapupCodes(data.entities);
          });
        } else {
          generateWrapupCodes();
        }
      })
      .catch((error) => {
        console.error("Error updating wrapup code:", error);
        setError("Failed to update wrapup code. Please try again.");
      });
  };

  const handleCancel = () => {
    setEditingCodeId(null);
  };

  const handleKeyDown = (e, wrapupCode) => {
    if (e.key === "Enter") {
      handleSave(wrapupCode);
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  const handleWrapupCodeCheckChange = (wrapupCodeId, checked) => {
    setError(""); // Clear any previous errors

    setSelectedWrapupCodes((prevSelectedWrapupCodes) => {
      if (checked) {
        if (prevSelectedWrapupCodes.length >= 100) {
          setError("You can only select up to 100 wrap-up codes.");
          return prevSelectedWrapupCodes; // Prevent adding more than 100
        }
        return [...prevSelectedWrapupCodes, { id: wrapupCodeId }];
      } else {
        return prevSelectedWrapupCodes.filter(
          (wrapupCode) => wrapupCode.id !== wrapupCodeId
        );
      }
    });
  };

  const handleQueueSearch = (value) => {
    if (value.trim() === "") {
      setQueueResults([]);
      return;
    }
    getQueue(value).then((data) => {
      setQueueResults(data.entities);
    });
  };

  const handleQueueCheckChange = (queueId, checked) => {
    setError("");
    setSelectedQueues((prevSelectedQueues) => {
      if (checked) {
        return [...prevSelectedQueues, queueId];
      } else {
        return prevSelectedQueues.filter((id) => id !== queueId);
      }
    });
  };

  const handleAssign = () => {
    const wrapupCodesIds = {
      data: selectedWrapupCodes,
    };
    postWrapupCodesInQueues(selectedQueues, wrapupCodesIds)
      .then(() => {
        setConfirmation("Wrapup codes assigned successfully.");
      })
      .catch((error) => {
        console.error(error);
        setError(error.message);
      });
    setTimeout(() => {
      setConfirmation("");
    }, 5000);
  };

  const renderWrapupCodeRow = (wrapupCode, index) => (
    <tr key={wrapupCode.id}>
      <th className="index">
        {pageNumber === 1 ? index + 1 : (pageNumber - 1) * 500 + index + 1}
      </th>
      <td>
        <DxCheckbox
          value="item-value"
          initialValue={selectedWrapupCodes.includes(wrapupCode.id)}
          name="name-string"
          onCheckChanged={(checked) =>
            handleWrapupCodeCheckChange(wrapupCode.id, checked)
          }
        />
      </td>
      <td>
        {editingCodeId === wrapupCode.id ? (
          <DxTextbox
            className="wrapup-edit-field"
            inputType="text"
            value={editingName}
            clearOnEscape={false}
            onChange={(value) => handleNameChange(value)}
            // onKeyboardEvent={(e) => handleKeyDown(e, wrapupCode)}
          />
        ) : (
          <span
            onClick={() => handleEditClick(wrapupCode)}
            style={{ cursor: "pointer" }}
          >
            {wrapupCode.name}
          </span>
        )}
      </td>
      <td>
        {editingCodeId === wrapupCode.id ? (
          <DxTextbox
            className="wrapup-edit-field"
            inputType="text"
            value={editingDescription}
            clearOnEscape={false}
            onChange={(value) => handleDescriptionChange(value)}
            // onKeyboardEvent={(e) => handleKeyDown(e, wrapupCode)}
          />
        ) : (
          <span
            onClick={() => handleEditClick(wrapupCode)}
            style={{ cursor: "pointer" }}
          >
            {wrapupCode.description}
          </span>
        )}
      </td>
      <td>
        {editingCodeId === wrapupCode.id ? (
          <DxItemGroup
            className="wrapup-edit-field"
            items={divisionsItemGroup}
            format="dropdown"
            onItemChanged={(item) => handleDivisionChange(item.value)}
          />
        ) : (
          <span
            onClick={() => handleEditClick(wrapupCode)}
            style={{ cursor: "pointer" }}
          >
            {wrapupCode.division.id === "*" ? " " : wrapupCode.division.name}
          </span>
        )}
      </td>
      <td className="wrapup-actions">
        {editingCodeId === wrapupCode.id ? (
          <>
            <button
              onClick={() => handleSave(wrapupCode)}
              className="wrapup-action-button"
            >
              <GenesysDevIcon icon={GenesysDevIcons.AppCheck} />
            </button>
            <button onClick={handleCancel} className="wrapup-action-button">
              <GenesysDevIcon icon={GenesysDevIcons.AppTimes} />
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => handleEditClick(wrapupCode)}
              className="wrapup-action-button"
            >
              <GenesysDevIcon icon={GenesysDevIcons.AppDocumentEdit} />
            </button>
          </>
        )}
      </td>
    </tr>
  );

  return (
    <>
      {isLoading ? ( // Show loading component while fetching data
        <Loading loadingText="Loading wrap-up codes..." />
      ) : (
        <>
          {wrapupCodes ? (
            <div
              className={`table ${
                selectedWrapupCodes.length >= 1
                  ? "split-table"
                  : "wrapup-codes-container"
              }`}
            >
              {/* <div className="wrapup-codes-container"> */}
              {/* <DxTextbox
                className="search-wrapupcodes"
                inputType="text"
                label="Search"
                icon={GenesysDevIcons.AppSearch}
                clearButton={true}
                onChange={(value) => setSearchInput(value)}
                changeDebounceMs={1000}
              /> */}
              <AlertBlock
                title="Select wrap-up codes to bulk assign them to queues."
                alertType="info"
                collapsible={false}
                autoCollapse={false}
                indentation={1}
                className="clazzy-alertblock w-max"
              />
              <table className="table">
                <thead>
                  <tr>
                    <th>Count</th>
                    <th></th>
                    <th>Wrap-Up Code</th>
                    <th>Wrap-Up Description</th>
                    <th>Wrap-up Code Division</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {searchWrapupCodesValue
                    ? filteredWrapupCodes.map(renderWrapupCodeRow)
                    : wrapupCodes.map(renderWrapupCodeRow)}
                </tbody>
              </table>
            </div>
          ) : (
            <h1>Loading...</h1>
          )}
          {selectedWrapupCodes.length >= 1 && (
            <div className="queue-assignment-container">
              <DxTextbox
                inputType="text"
                label="Queue Search"
                icon={GenesysDevIcons.AppSearch}
                clearButton={true}
                onChange={(value) => handleQueueSearch(value)}
                changeDebounceMs={500}
                description="Search for Queues to assign the wrapup code to."
              />
              {queueResults.length > 0 &&
                queueResults.map((queue) => (
                  <DxCheckbox
                    key={queue.id}
                    label={queue.name}
                    value="item-value"
                    initialValue={selectedQueues.includes(queue.id)}
                    name="name-string"
                    onCheckChanged={(checked) =>
                      handleQueueCheckChange(queue.id, checked)
                    }
                  />
                ))}
              {selectedQueues.length > 0 && (
                <DxButton type="primary" onClick={handleAssign}>
                  Assign
                </DxButton>
              )}
              {confirmation && (
                <AlertBlock
                  title={confirmation}
                  alertType="success"
                  collapsible={false}
                  autoCollapse={false}
                  indentation={1}
                  className="clazzy-alertblock alert-wrapupcodes"
                />
              )}
              {error && (
                <AlertBlock
                  title={error}
                  alertType="warning"
                  collapsible={false}
                  autoCollapse={false}
                  indentation={1}
                  className="clazzy-alertblock alert-wrapupcodes"
                />
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}
